/**
 * Global Declarations.
 */
/// <reference types="vite-plugin-svgr/client" />

/**
 * Polyfills
 */
import "navigator.locks";

/**
 * Imports (Ordered).
 */
import { mountApp } from "@/app/mount";
import { globalStateModule } from "@/modules/global-state";
import { globalStateService as commonEditorGlobalStateModule } from "@mem-labs/common-editor";

/**
 * App Setup.
 */
import { handleEphemeralRoutes } from "@/app/router/handle-ephemeral-routes";
import { registerEphemeralRouteHandlers } from "@/app/router/ephemeral-routes";
import { captureAndStripMarketingAttribution } from "@/app/router/marketing-attribution";
import { initializeDesktopMarketingAttributionHandoff } from "@/app/router/desktop-marketing-attribution-handoff";

const startApp = async () => {
  await initializeDesktopMarketingAttributionHandoff();

  // Preserve the Market campaign and browser identity before routing or auth
  // strips the handoff params.
  captureAndStripMarketingAttribution();

  registerEphemeralRouteHandlers();
  handleEphemeralRoutes();

  await globalStateModule.initialize();
  await commonEditorGlobalStateModule.initialize();

  mountApp();
};

startApp();
